export enum AuthFlowType {
  RECOVER_PASSWORD = 'recover-password',
  PHONE_REGISTRATION = 'phone-registration',
  EMAIL_REGISTRATION = 'email-registration',
  SITE_CREDENTIALS = 'site-credentials',
  PHONE_LOGIN_EMAIL_ASSOCIATION = 'phone-login-email-association',
}

export enum AuthStepType {
  VALIDATE_PASSWORD = 'validate-password',
  SET_PASSWORD = 'set-password',
  VERIFY_OTP = 'verify-otp',
  RECOVER_PIN = 'recover-pin',
  PHONE_ASSOCIATION = 'phone-association',
  EMAIL_ASSOCIATION = 'email-association',
  MFA_VALIDATION = 'mfa-validation'
}

export interface FlowConfig {
  form: string;
  flow: AuthFlowType;
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    input: string;
    inputAria: string;
    inputRepeat: string;
    inputRepeatAria: string;
    nextButton: string;
    nextButtonAria?: {
      disabled: string;
      enabled: string;
    };
  },
  previousStepBackXTimes: number;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.RECOVER_PASSWORD]: {
    form: "set_password__" + AuthFlowType.RECOVER_PASSWORD,
    flow: AuthFlowType.RECOVER_PASSWORD,
    labels: {
      headerTitle: "password_definition.header_title",
      headerSubtitle: "password_definition.header_message",
      input: 'password_definition.password_input',
      inputAria: 'accessibility.email.login.validate_password.input',
      inputRepeat: 'password_definition.confirm_password_input',
      inputRepeatAria: 'accessibility.password_recover.set_password.confirmation_input',
      nextButton: 'password_definition.button_next_message',
      nextButtonAria: {
        disabled: 'accessibility.password_recover.set_password.button.cant_submit',
        enabled: 'accessibility.password_recover.set_password.button.submit',
      }
    },
    previousStepBackXTimes: 2
  },
  [AuthFlowType.PHONE_REGISTRATION]: {
    form: "set_password__" + AuthFlowType.PHONE_REGISTRATION,
    flow: AuthFlowType.PHONE_REGISTRATION,
    labels: {
      headerTitle: "password_definition.header_title",
      headerSubtitle: "password_definition.header_message",
      input: 'password_definition.password_input',
      inputAria: 'accessibility.phonenumber.registration.set_password.input',
      inputRepeat: 'password_definition.confirm_password_input',
      inputRepeatAria: 'accessibility.phonenumber.registration.set_password.confirmation_input',
      nextButton: 'password_definition.button_next_message',
      nextButtonAria: {
        disabled: 'accessibility.phonenumber.registration.set_password.button.cant_submit',
        enabled: 'accessibility.phonenumber.registration.set_password.button.submit',
      }
    },
    previousStepBackXTimes: 1
  },
  [AuthFlowType.EMAIL_REGISTRATION]: {
    form: "set_password__" + AuthFlowType.EMAIL_REGISTRATION,
    flow: AuthFlowType.EMAIL_REGISTRATION,
    labels: {
      headerTitle: "password_definition.header_title",
      headerSubtitle: "password_definition.header_message",
      input: 'password_definition.password_input',
      inputAria: 'accessibility.phonenumber.registration.set_password.input',
      inputRepeat: 'password_definition.confirm_password_input',
      inputRepeatAria: 'accessibility.phonenumber.registration.set_password.confirmation_input',
      nextButton: 'password_definition.button_next_message',
      nextButtonAria: {
        disabled: 'accessibility.phonenumber.registration.set_password.button.cant_submit',
        enabled: 'accessibility.phonenumber.registration.set_password.button.submit',
      }
    },
    previousStepBackXTimes: 1
  },
  [AuthFlowType.SITE_CREDENTIALS]: {
    form: "set_password__" + AuthFlowType.SITE_CREDENTIALS,
    flow: AuthFlowType.SITE_CREDENTIALS,
    labels: {
      headerTitle: "site_credentials.define_password",
      input: 'site_credentials.password_input',
      inputAria: 'accessibility.phonenumber.registration.set_password.input',
      inputRepeat: 'site_credentials.confirm_password',
      inputRepeatAria: 'accessibility.phonenumber.registration.set_password.confirmation_input',
      nextButton: 'site_credentials.button_next_message',
      nextButtonAria: {
        disabled: 'accessibility.phonenumber.registration.set_password.button.cant_submit',
        enabled: 'accessibility.phonenumber.registration.set_password.button.submit',
      }
    },
    previousStepBackXTimes: 2
  },
  [AuthFlowType.PHONE_LOGIN_EMAIL_ASSOCIATION]: {
    form: "set_password__" + AuthFlowType.PHONE_LOGIN_EMAIL_ASSOCIATION,
    flow: AuthFlowType.PHONE_LOGIN_EMAIL_ASSOCIATION,
    labels: {
      headerTitle: "password_definition.header_title",
      headerSubtitle: "password_definition.header_message",
      input: 'password_definition.password_input',
      inputAria: 'accessibility.phonenumber.registration.set_password.input',
      inputRepeat: 'password_definition.confirm_password_input',
      inputRepeatAria: 'accessibility.phonenumber.registration.set_password.confirmation_input',
      nextButton: 'password_definition.button_next_message',
      nextButtonAria: {
        disabled: 'accessibility.phonenumber.registration.set_password.button.cant_submit',
        enabled: 'accessibility.phonenumber.registration.set_password.button.submit',
      }
    },
    previousStepBackXTimes: 2
  },
};